const AI_BASE_URL =
  process.env.GLOBAL_ENV === 'prod'
    ? 'https://medikus.medpoint.pro/api/'
    : 'https://debug-medikus.medpoint.pro/api/'

const INSTRUCTION_DATA = [
  {
    advice: 'Будьте конкретны: укажите точный диагноз или симптомы.',
    example: 'Пример: «Лечение гипертонии 2 степени» вместо «Высокое давление»',
  },
  {
    advice: 'Уточняйте детали: возраст пациента, сопутствующие заболевания, стадия болезни.',
    example: 'Пример: «Лечение язвы желудка у пациента 45 лет с сахарным диабетом»',
  },
  {
    advice: 'Формулируйте четко: задавайте вопрос ясно и по существу. ',
    example: 'Пример: «Какие препараты рекомендованы при бронхиальной астме средней тяжести?»',
  },
  {
    advice: 'Используйте медицинские термины: это поможет системе точнее найти информацию.',
    example: 'Пример: «Дифференциальная диагностика при мелкоклеточном раке легкого»',
  },
  {
    advice: 'Указывайте цель запроса: Диагностика, лечение, профилактика и т.д.',
    example: 'Пример: «Методы профилактики тромбоза глубоких вен после операции»',
  },
]
const INSTRUCTION_CLINIC_DATA = {
  title_advice: 'Для точного ответа:',
  advices: [
    'определите, что вас интересует: диагностика, лечение, профилактика, критерии эффективности, показания/противопоказания к процедуре и т.д.;',
    'запрос должен быть напрямую связан с заболеванием, метом диагностики или лечения, описанным в выбранной КР.',
  ],
  example_good:
    'Клиническая рекомендация «Гипертрофическая кардиомиопатия».<br/>Запрос: Что является показанием к проведению биопсии сердца?',
  title_non_advice: 'Как не стоит задавать вопросы:',
  non_advices: [
    'не указывайте детали о пациенте, его пол, возраст, анамнез;',
    'не просите определить диагноз;',
    'избегайте вопросов вне выбранной клинической рекомендации.',
  ],
  example_bad:
    'Клиническая рекомендация «Гипертрофическая кардиомиопатия».<br/>Запрос: Представь, что ты врач-терапевт с 15-летним стажем. Пациент: мужчина, 46 лет, курит, жалуется на давящие боли за грудиной при ходьбе. Какие исследования ему назначить? Какой предварительный диагноз? Перенес ковид 2 месяца назад.',
}

const ONBOARDING_CONFIG = [
  {
    title: 'Получайте подробные ответы',
    text: 'Нужно больше информации? Используйте кнопку «Уточнить по этому вопросу» для дополнительных деталей',
    imgWidth: 222,
    imgHeight: 173,
  },
  {
    title: 'Легко переключайтесь между клинреками',
    text: 'Интересует другое заболевание?<br>Просто задайте новый вопрос! AI Bolit мгновенно найдет релевантную информацию из обширной базы клинических рекомендаций',
    imgWidth: 223,
    imgHeight: 104,
  },
  {
    title: '<span>Ваш вклад </span>в совершенствование AI Bolit',
    text: 'Заметили неточность? Сообщите нам! Ваша обратная связь — ключ к постоянному улучшению AI Bolit. Вместе мы делаем сервис точнее и эффективнее',
    imgWidth: 187,
    imgHeight: 110,
    whiteText: true,
  },
]

export { AI_BASE_URL, INSTRUCTION_DATA, INSTRUCTION_CLINIC_DATA, ONBOARDING_CONFIG }
